import { render, staticRenderFns } from "./Firmwares.vue?vue&type=template&id=dc1cfb58&scoped=true"
import script from "./Firmwares.vue?vue&type=script&lang=js"
export * from "./Firmwares.vue?vue&type=script&lang=js"
import style0 from "./Firmwares.vue?vue&type=style&index=0&id=dc1cfb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1cfb58",
  null
  
)

export default component.exports